import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form, Button, Alert, Badge, Spinner, Toast } from 'react-bootstrap';
import { CircularProgress, Box } from '@mui/material';
import ExperienciaProveedor from './ExperienciaProveedor';
import UafeEvidencia from './UafeEvidencia';
import axios from 'axios';

const SupplierQualificationForm = ({
  formularioId,
  tipoPersona,
  calificacionData,
  onCalificacionCompletada
}) => {
  const [parametros, setParametros] = useState([]);
  const [proveedorInfo, setProveedorInfo] = useState({});
  const [respuestas, setRespuestas] = useState({});
  const [documentos, setDocumentos] = useState({});
  const [certificadosAdicionales, setCertificadosAdicionales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [notas, setNotas] = useState({});
  const [experienciaGuardada, setExperienciaGuardada] = useState(false);
  const [totales, setTotales] = useState({
    totalPuntos: 0,
    totalObtenido: 0,
    porcentaje: 0,
    resultado: 'NO CALIFICA'
  });
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [disable5_5, setDisable5_5] = useState(false);
  const [observacionesCalificacion, setObservacionesCalificacion] = useState('');
  const [fechaInicioActividad, setFechaInicioActividad] = useState('');
  const [fechaCalificacion, setFechaCalificacion] = useState('');
  const [experienciaCompletada, setExperienciaCompletada] = useState(false);
  const [calificacionFinal, setCalificacionFinal] = useState(0);
  const [uafeCalifica, setUafeCalifica] = useState(null);

  const token = localStorage.getItem('token');

  const mostrarToast = (mensaje) => {
    setToastMessage(mensaje);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const abrirDocumento = async (rutaArchivo) => {
    if (!rutaArchivo) {
      mostrarToast('No hay archivo disponible');
      return;
    }

    try {
      const url = `https://apiprov.conduto.com.ec/api/documentos/visualizar/${encodeURIComponent(rutaArchivo)}`;
      window.open(url, '_blank');
    } catch (error) {
      console.error('Error al abrir documento:', error);
      mostrarToast('Error al abrir el documento');
    }
  };

  const calcularNotaParametro = (parametro, respuesta) => {
    if (!respuesta || respuesta.estado === 'no_aplica') return 0;
    if (parametro.seccion === '5_4') {
      switch (respuesta.estado) {
        case 'cumple': return 5;
        case 'parcial': return 2.5;
        case 'no_cumple': return 1;
        default: return 0;
      }
    } else {
      return respuesta.estado === 'cumple' ? parametro.puntaje_maximo : 0;
    }
  };

  const calcularNotas = () => {
    if (uafeCalifica === false) {
      setTotales({
        totalPuntos: 100,
        totalObtenido: 0,
        porcentaje: 0,
        resultado: 'NO CALIFICA'
      });
      setCalificacionFinal(0);
      return;
    }

    let totalPuntos = 0;
    let totalObtenido = 0;
    const nuevasNotas = {};

    const parametros5_4 = parametros.filter(p => p.seccion === '5_4');
    const parametros5_5 = parametros.filter(p => p.seccion === '5_5');

    let tieneCumple5_4 = false;
    let cumpleParcialCount = 0;

    parametros5_4.forEach(p => {
      const resp = respuestas[p.id_pregunta];
      const nota = calcularNotaParametro(p, resp);
      nuevasNotas[p.id_pregunta] = nota;
      totalPuntos += p.puntaje_maximo;
      totalObtenido += nota;

      if (resp?.estado === 'cumple') {
        tieneCumple5_4 = true;
      }
      if (resp?.estado === 'parcial') {
        cumpleParcialCount++;
      }
    });

    if (tieneCumple5_4 || cumpleParcialCount >= 2) {
      parametros5_5.forEach(p => {
        nuevasNotas[p.id_pregunta] = p.puntaje_maximo;
        totalPuntos += p.puntaje_maximo;
        totalObtenido += p.puntaje_maximo;
      });
      setDisable5_5(true);
      setCalificacionFinal(100);
    } else {
      parametros5_5.forEach(p => {
        const resp = respuestas[p.id_pregunta];
        const nota = resp?.estado === 'cumple' ? p.puntaje_maximo : 0;
        nuevasNotas[p.id_pregunta] = nota;
        totalPuntos += p.puntaje_maximo;
        totalObtenido += nota;
      });
      setDisable5_5(false);
      setCalificacionFinal(totalObtenido);
    }

    const porcentaje = totalPuntos > 0 ? (totalObtenido / totalPuntos) * 100 : 0;
    let resultado;

    if (porcentaje >= 60) {
      resultado = 'PROVEEDOR CALIFICA';
    } else if (porcentaje >= 46) {
      resultado = 'CUMPLE PARCIALMENTE';
    } else {
      resultado = 'NO CALIFICA';
    }

    setNotas(nuevasNotas);
    setTotales({ totalPuntos, totalObtenido, porcentaje, resultado });
  };

  useEffect(() => {
    if (parametros.length && Object.keys(respuestas).length) {
      calcularNotas();
    }
  }, [respuestas, parametros, uafeCalifica]);

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        setLoading(true);

        const resPar = await fetch(
          `https://apiprov.conduto.com.ec/api/documentos/preguntas-por-formulario/${formularioId}`,
          {
            credentials: 'include',
            headers: {
              'Authorization': `Bearer ${token}`
            }
          }
        );

        if (!resPar.ok) {
          throw new Error('Error cargando parámetros');
        }

        const parametrosData = await resPar.json();
        setParametros(parametrosData);

        const resInfo = await axios.get(`https://apiprov.conduto.com.ec/api/providers/proveedor-datos/${formularioId}`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${token}` }
        });

        const resDocs = await axios.get(`https://apiprov.conduto.com.ec/api/documentos/respuestas-con-parametros-proveedor?id_formulario=${formularioId}`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${token}` }
        });

        const resAdicionales = await axios.get(`https://apiprov.conduto.com.ec/api/documentos/certificados-adicionales?id_formulario=${formularioId}`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${token}` }
        }).catch(err => ({ data: [] }));

        let respuestasExistentes = {};
        if (calificacionData?.id_calificacion) {
          try {
            const resDetalles = await axios.get(`https://apiprov.conduto.com.ec/api/calificaciones/${calificacionData.id_calificacion}`, {
              withCredentials: true,
              headers: { Authorization: `Bearer ${token}` }
            });

            if (resDetalles.data.detalles) {
              resDetalles.data.detalles.forEach(detalle => {
                respuestasExistentes[detalle.id_parametro] = {
                  estado: detalle.estado,
                  puntaje_obtenido: detalle.puntaje_obtenido
                };
              });
            }
          } catch (err) {
            console.error('Error cargando detalles de calificación:', err);
          }
        }

        const initialRespuestas = {};
        parametrosData.forEach(param => {
          if (!respuestasExistentes[param.id_pregunta]) {
            initialRespuestas[param.id_pregunta] = { estado: '', puntaje_obtenido: 0 };
          } else {
            initialRespuestas[param.id_pregunta] = respuestasExistentes[param.id_pregunta];
          }
        });

        setRespuestas(initialRespuestas);

        if (resInfo.data) setProveedorInfo(resInfo.data);

        if (resDocs.data) {
          const map = {};
          resDocs.data.forEach(d => {
            map[d.id_parametro] = {
              ruta_archivo: d.ruta_archivo,
              nombre_archivo: d.nombre_archivo
            };
          });
          setDocumentos(map);
        }

        if (resAdicionales.data && Array.isArray(resAdicionales.data)) {
          setCertificadosAdicionales(resAdicionales.data);
        }

      } catch (err) {
        console.error('Error cargando datos:', err);
        setError(err.message || 'Error al cargar los datos');
      } finally {
        setLoading(false);
      }
    };

    if (formularioId && tipoPersona) {
      cargarDatos();
    }
  }, [formularioId, tipoPersona, calificacionData]);

  useEffect(() => {
    const cargarObservacionesExistentes = async () => {
      try {
        if (calificacionData?.id_calificacion) {
          const response = await fetch(
            `https://apiprov.conduto.com.ec/api/calificaciones/${calificacionData.id_calificacion}`,
            {
              credentials: 'include',
              headers: {
                'Authorization': `Bearer ${token}`
              }
            }
          );

          if (response.ok) {
            const data = await response.json();
            const observaciones = data.calificacion?.observaciones || '';
            setObservacionesCalificacion(observaciones);
          }
        }
      } catch (error) {
        console.error('Error al cargar observaciones existentes:', error);
      }
    };

    cargarObservacionesExistentes();
  }, [calificacionData?.id_calificacion, token]);

  useEffect(() => {
    setExperienciaCompletada(fechaInicioActividad !== '' && fechaCalificacion !== '');
  }, [fechaInicioActividad, fechaCalificacion]);

  const handleRespuestaChange = async (idParametro, campo, valor) => {
    setRespuestas(prev => {
      const nuevaRespuesta = {
        ...prev[idParametro],
        [campo]: valor
      };

      setTimeout(() => guardarEnBackend(idParametro, nuevaRespuesta), 0);

      return {
        ...prev,
        [idParametro]: nuevaRespuesta
      };
    });
  };

  const guardarEnBackend = async (idParametro, respuestaActualizada) => {
    try {
      const parametro = parametros.find(p => p.id_pregunta === idParametro);

      if (parametro && parametro.seccion === '5_5' && disable5_5) {
        respuestaActualizada.puntaje_obtenido = parametro.puntaje_maximo;
        respuestaActualizada.estado = 'cumple';
      }

      const response = await fetch(`https://apiprov.conduto.com.ec/api/calificaciones/${calificacionData.id_calificacion}/detalle/${idParametro}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        credentials: 'include',
        body: JSON.stringify(respuestaActualizada)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Error al guardar los cambios');
      }

    } catch (error) {
      console.error('Error al guardar:', error);
      mostrarToast(error.message);

      setRespuestas(prev => ({
        ...prev,
        [idParametro]: {
          ...prev[idParametro],
          estado: prev[idParametro]?.estado || 'no_aplica'
        }
      }));
    }
  };

  const guardarCalificacionFinal = async () => {
    try {
      const calificacionId = calificacionData.id_calificacion;

      let resultadoBackend = 'no_califica';
      if (totales.resultado === 'PROVEEDOR CALIFICA') {
        resultadoBackend = 'califica';
      } else if (totales.resultado === 'CUMPLE PARCIALMENTE') {
        resultadoBackend = 'cumple_parcialmente';
      }

      const calificacionDataBody = {
        calificacion_final: calificacionFinal,
        resultado: resultadoBackend,
        fecha_calificacion: new Date().toISOString()
      };

      const response = await fetch(`https://apiprov.conduto.com.ec/api/calificaciones/${calificacionId}/calificacion-final`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        credentials: 'include',
        body: JSON.stringify(calificacionDataBody)
      });

      if (!response.ok) {
        throw new Error('Error al guardar calificación final');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };

  const guardarCalificacionCompleta = async () => {
    if (!experienciaCompletada) {
      mostrarToast('Debe completar todos los campos de experiencia del proveedor');
      return;
    }

    try {
      setSaving(true);

      const calificacionResponse = await fetch(
        `https://apiprov.conduto.com.ec/api/calificaciones`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          credentials: 'include',
          body: JSON.stringify({
            id_formulario: formularioId,
            id_usuario: calificacionData?.id_usuario || 1,
            tipo_persona: tipoPersona,
            observaciones: observacionesCalificacion
          })
        }
      );

      const calificacionResult = await calificacionResponse.json();
      if (!calificacionResponse.ok) throw new Error('Error al guardar calificación');

      const calificacionId = calificacionResult.calificacion.id_calificacion;

      await guardarCalificacionFinal();

      await fetch(
        `https://apiprov.conduto.com.ec/api/calificaciones/${calificacionId}/observaciones`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          credentials: 'include',
          body: JSON.stringify({
            observaciones: observacionesCalificacion
          })
        }
      );

      const calificadoResponse = await fetch(
        `https://apiprov.conduto.com.ec/api/formularios/${formularioId}/marcar-calificado`,
        {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          credentials: 'include'
        }
      );

      if (calificadoResponse.ok) {
        mostrarToast('Formulario calificado exitosamente');
        if (onCalificacionCompletada) onCalificacionCompletada();
      }

    } catch (err) {
      setError(err.message);
      mostrarToast(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleUafeCalificacionChange = (califica) => {
    setUafeCalifica(califica);
    if (califica === false) {
      mostrarToast('El proveedor no califica según UAFE. La calificación se ha establecido en 0.');
    }
  };

  const renderBotonDocumento = (parametro) => {
    const doc = documentos[parametro.id_pregunta];

    if (!doc || !doc.ruta_archivo) {
      return (
        <div>
          <span className="text-muted">{parametro.titulo}</span>
          <br />
          <small className="text-danger">No se ha subido documento</small>
        </div>
      );
    }

    return (
      <div>
        <Button
          variant="link"
          className="p-0 text-start text-decoration-none"
          onClick={() => abrirDocumento(doc.ruta_archivo)}
          title="Ver documento"
        >
          <span className="text-primary">
            {parametro.titulo}
          </span>
          <br />
          <small className="text-muted">{doc.nombre_archivo}</small>
        </Button>
      </div>
    );
  };

  const renderSeccionCalificacion = (seccion, titulo) => {
    const parametrosSeccion = parametros.filter(p => p.seccion === seccion);
    if (parametrosSeccion.length === 0) return null;
    const isDisabled = seccion === '5_5' && disable5_5;

    return (
      <Card className="mb-4">
        <Card.Header className="bg-light">
          <h5 className="mb-0">{titulo}</h5>
        </Card.Header>
        <Card.Body>
          {isDisabled && (
            <Alert variant="info">
              Sección 5.4 tiene al menos un ítem calificado como "Cumple" o dos como "Cumple parcialmente". Esta sección se califica automáticamente con 100 puntos.
            </Alert>
          )}
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr style={{ color: 'blue' }}>
                  <th>Parámetro</th>
                  {seccion === '5_4' && (
                    <>
                      <th className="text-center">No aplicable</th>
                      <th className="text-center">Cumple</th>
                      <th className="text-center">Cumple parcialmente</th>
                      <th className="text-center">No cumple</th>
                    </>
                  )}
                  {seccion !== '5_4' && (
                    <>
                      <th className="text-center">Cumple</th>
                      <th className="text-center">No cumple</th>
                    </>
                  )}
                  <th className="text-center">Puntuación máxima</th>
                  <th className="text-center">Nota</th>
                </tr>
              </thead>
              <tbody>
                {parametrosSeccion.map(parametro => (
                  <tr key={parametro.id_pregunta}>
                    <td>
                      {renderBotonDocumento(parametro)}
                    </td>
                    {seccion === '5_4' && (
                      <>
                        <td className="text-center">
                          <Form.Check
                            type="radio"
                            name={`param-${parametro.id_pregunta}`}
                            checked={respuestas[parametro.id_pregunta]?.estado === 'no_aplica'}
                            onChange={() => handleRespuestaChange(parametro.id_pregunta, 'estado', 'no_aplica')}
                            disabled={uafeCalifica === false}
                          />
                        </td>
                        <td className="text-center">
                          <Form.Check
                            type="radio"
                            name={`param-${parametro.id_pregunta}`}
                            checked={respuestas[parametro.id_pregunta]?.estado === 'cumple'}
                            onChange={() => handleRespuestaChange(parametro.id_pregunta, 'estado', 'cumple')}
                            disabled={uafeCalifica === false}
                          />
                        </td>
                        <td className="text-center">
                          <Form.Check
                            type="radio"
                            name={`param-${parametro.id_pregunta}`}
                            checked={respuestas[parametro.id_pregunta]?.estado === 'parcial'}
                            onChange={() => handleRespuestaChange(parametro.id_pregunta, 'estado', 'parcial')}
                            disabled={uafeCalifica === false}
                          />
                        </td>
                        <td className="text-center">
                          <Form.Check
                            type="radio"
                            name={`param-${parametro.id_pregunta}`}
                            checked={respuestas[parametro.id_pregunta]?.estado === 'no_cumple'}
                            onChange={() => handleRespuestaChange(parametro.id_pregunta, 'estado', 'no_cumple')}
                            disabled={uafeCalifica === false}
                          />
                        </td>
                      </>
                    )}
                    {seccion !== '5_4' && (
                      <>
                        <td className="text-center">
                          <Form.Check
                            type="radio"
                            name={`param-${parametro.id_pregunta}`}
                            checked={respuestas[parametro.id_pregunta]?.estado === 'cumple'}
                            onChange={() => handleRespuestaChange(parametro.id_pregunta, 'estado', 'cumple')}
                            disabled={isDisabled || uafeCalifica === false}
                          />
                        </td>
                        <td className="text-center">
                          <Form.Check
                            type="radio"
                            name={`param-${parametro.id_pregunta}`}
                            checked={respuestas[parametro.id_pregunta]?.estado === 'no_cumple'}
                            onChange={() => handleRespuestaChange(parametro.id_pregunta, 'estado', 'no_cumple')}
                            disabled={isDisabled || uafeCalifica === false}
                          />
                        </td>
                      </>
                    )}
                    <td className="text-center">{parametro.puntaje_maximo}</td>
                    <td className="text-center fw-bold">{notas[parametro.id_pregunta] || 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>
    );
  };

  const renderAdicionales = () => {
    if (certificadosAdicionales.length === 0) return null;

    return (
      <Card className="mb-4">
        <Card.Header className="text-white">
          <h5 className="mb-0">Certificados Adicionales</h5>
        </Card.Header>
        <Card.Body>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr style={{ color: 'blue' }}>
                  <th>Certificado</th>
                  <th className="text-start">Documento</th>
                  <th className="text-start">Descripción</th>
                </tr>
              </thead>
              <tbody>
                {certificadosAdicionales.map(cert => {
                  return (
                    <tr key={cert.id_certificado}>
                      <td>
                        <strong>{cert.titulo}</strong>
                      </td>
                      <td className="text-start">
                        {cert.ruta_archivo ? (
                          <div>
                            <Button
                              variant="link"
                              onClick={() => abrirDocumento(cert.ruta_archivo)}
                              title="Ver documento"
                            >
                              {cert.ruta_archivo.split('/').pop()}
                            </Button>
                          </div>
                        ) : (
                          <span className="text-danger">No se ha subido documento</span>
                        )}
                      </td>
                      <td className="text-start">
                        {cert.descripcion || 'Sin descripción'}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>
    );
  };

  if (loading) return (
    <Box display="flex" justifyContent="center" mt={4}>
      <CircularProgress />
    </Box>
  );

  const puedeFinalizar = experienciaCompletada && experienciaGuardada && uafeCalifica !== false;

  return (
    <div className="supplier-qualification-form">
      <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 9999 }}>
        <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide style={{ backgroundColor: '#198754', color: '#ffffff', border: '1px solid #198754', minWidth: 220 }}>
          <Toast.Body className="d-flex align-items-center gap-2">
            <span style={{ fontSize: 22, color: '#ffffff' }}>
              <i className="bi bi-check-circle-fill"></i>
            </span>
            <span>{toastMessage}</span>
          </Toast.Body>
        </Toast>
      </div>

      <Card className="mb-4 shadow-sm border-0">
        <Card.Header className="bg-light">
          <h5 className="mb-0">Información del Proveedor</h5>
        </Card.Header>
        <Card.Body>
          <Row className="g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label><strong>Nombre Proveedor de servicios / productos:</strong></Form.Label>
                <Form.Control type="text" value={proveedorInfo.razon_social || ''} readOnly />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label><strong>Suministro / Servicios prestados:</strong></Form.Label>
                <Form.Control type="text" value={proveedorInfo.servicios_prestados || ''} readOnly />
              </Form.Group>
            </Col>
          </Row>

          <Row className="g-3 mt-1">
            <Col md={4}>
              <Form.Group>
                <Form.Label><strong>Contacto:</strong></Form.Label>
                <Form.Control type="text" value={proveedorInfo.persona_contacto || ''} readOnly />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label><strong>Cargo:</strong></Form.Label>
                <Form.Control type="text" value={proveedorInfo.cargo || ''} readOnly />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label><strong>Teléfono:</strong></Form.Label>
                <Form.Control type="text" value={proveedorInfo.telefono1 || ''} readOnly />
              </Form.Group>
            </Col>
          </Row>

          <Row className="g-3 mt-1">
            <Col md={3}>
              <Form.Group>
                <Form.Label><strong>RUC:</strong></Form.Label>
                <Form.Control type="text" value={proveedorInfo.ruc || ''} readOnly />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label><strong>Email:</strong></Form.Label>
                <Form.Control type="text" value={proveedorInfo.email_contacto || ''} readOnly />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label><strong>Dirección:</strong></Form.Label>
                <Form.Control type="text" value={proveedorInfo.direccion_establecimiento || ''} readOnly />
              </Form.Group>
            </Col>
          </Row>

          <Row className="g-3 mt-1">
            <Col md={6}>
              <Form.Group>
                <Form.Label><strong>Cantón:</strong></Form.Label>
                <Form.Control type="text" value={proveedorInfo.canton || ''} readOnly />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label><strong>Provincia:</strong></Form.Label>
                <Form.Control type="text" value={proveedorInfo.provincia || ''} readOnly />
              </Form.Group>
            </Col>
          </Row>

          {tipoPersona === 'juridica' && (
            <>
              <Row className="g-3 mt-1">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label><strong>Representante Legal:</strong></Form.Label>
                    <Form.Control type="text" value={proveedorInfo.representante_legal || ''} readOnly />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label><strong>Cargo:</strong></Form.Label>
                    <Form.Control type="text" value={proveedorInfo.cargo || ''} readOnly />
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </Card.Body>
      </Card>

      <UafeEvidencia
        formularioId={formularioId}
        onCalificacionChange={handleUafeCalificacionChange}
      />

      {renderSeccionCalificacion('5_4', 'CALIFICACIÓN SEGÚN ART. 5.4 DEL PROCEDIMIENTO 1-PR-CCC-SEDE-001')}
      {renderSeccionCalificacion('5_5', 'CALIFICACIÓN SEGÚN ART. 5.5 DEL PROCEDIMIENTO 1-PR-CCC-SEDE-001')}
      {renderAdicionales()}

      <Card className="mb-4">
        <Card.Header className="bg-light"><h5 className="mb-0">Resultados de Evaluación</h5></Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Fecha de Caducidad:</strong></Form.Label>
                <Form.Control type="date" value={new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Total de puntos posibles:</strong></Form.Label>
                <Form.Control type="text" value={100} disabled />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Total de la Nota:</strong></Form.Label>
                <Form.Control type="text" value={uafeCalifica === false ? 0 : totales.totalObtenido} disabled />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Porcentual:</strong></Form.Label>
                <Form.Control type="text" value={uafeCalifica === false ? '0%' : `${totales.totalObtenido.toFixed(2)}%`} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Resultado:</strong></Form.Label>
                <div>
                  <Badge
                    bg={uafeCalifica === false ? 'danger' : (totales.resultado === 'PROVEEDOR CALIFICA' ? 'success' : totales.resultado === 'CUMPLE PARCIALMENTE' ? 'warning' : 'danger')}
                    className="fs-6 p-2"
                  >
                    {uafeCalifica === false ? 'NO CALIFICA' : totales.resultado}
                  </Badge>
                </div>
              </Form.Group>
            </Col>
          </Row>
          <ExperienciaProveedor
            fechaInicioActividad={fechaInicioActividad}
            setFechaInicioActividad={setFechaInicioActividad}
            fechaCalificacion={fechaCalificacion}
            setFechaCalificacion={setFechaCalificacion}
            proveedorInfo={proveedorInfo}
            calificacionId={calificacionData?.id_calificacion}
            onExperienciaGuardada={setExperienciaGuardada}
          />
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label><strong>Disposiciones, comentarios o observaciones (CALIFICACIÓN):</strong></Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={observacionesCalificacion}
                  onChange={(e) => setObservacionesCalificacion(e.target.value)}
                  placeholder="Ingrese observaciones específicas para la calificación del proveedor"
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {error && <Alert variant="danger" onClose={() => setError('')} dismissible>{error}</Alert>}

      <div className="d-flex justify-content-end gap-2">
        <Button
          variant="primary"
          onClick={guardarCalificacionCompleta}
          disabled={saving || !puedeFinalizar}
        >
          {saving ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Guardando...
            </>
          ) : (
            'Finalizar Calificación'
          )}
        </Button>
      </div>
    </div>
  );
};

export default SupplierQualificationForm;